import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Stack, Button, InputBase, Tabs, Tab, Drawer, Typography, Fab } from "@mui/material";
import { styled } from "@mui/system";
import {
  getSellerTabPost,
  handleBookmarkPost,
  handleLikePost,
} from "../../appStore/actions/ArkchatGroup/action";
import PostCard from "../post/commonComponent/PostCard/PostCard";
import { serviceTypeName, serviceTypeValue, accountType, AccountLevelArkchatPermission } from "../../utils/constant";
import ExploreView from "../explore/ExploreView";
import HelperScreen from "../../common/ToolTip/HelperScreen";
import { useTranslation } from "react-i18next";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import LoadingSpinner from "../../common/LoadingSpinner/LoadingSpinner";
import { getServiceCategory, getCountryList } from "../../appStore/actions/masterData/masterDataAction";
import { handleSavePreviewEditPostData, handleSetserviceTypePost } from "../../appStore/actions/AppState/action";
import { useNavigate } from "react-router-dom";
import AlertPopUp from "../../common/AlertPopUp";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import productLogo from "../../assets/images/post/Product.svg";
import artWorkLogo from "../../assets/images/post/Artwork.svg";
import serviceLogo from "../../assets/images/post/service.svg";
import { crossIcon, crossIconDiv } from "../../assets/commonFunction";
import MyFeedPostsTab from "../../common/MyFeedPostsTab";

const StyledSubHeadingBox = styled(Box)({
  display: "flex",
  alignItems: "center",
  backgroundColor: "#F3F3F3",
  marginBottom: "0.5rem",
});

const SearchBar = styled(Box)({
  display: "flex",
  alignItems: "center",
  width: "100%",
  border: "1px solid #000000",
  backgroundColor: "#FFFFFF",
  height: "30px",
  minHeight: "30px",
  maxHeight: "30px",
  boxSizing: "border-box",
});

const IconButtonBox = styled(Button)({
  minWidth: "30px",
  maxWidth: "30px",
  width: "30px",
  height: "30px",
  minHeight: "30px",
  maxHeight: "30px",
  padding: "4px",
  borderRadius: "0.15rem",
  border: "1px solid #000000",
  backgroundColor: "#FFFFFF",
  color: "#111111",
  boxSizing: "border-box",
  "&:hover": {
    backgroundColor: "#FFFFFF",
  },
});

const actionIconSx = {
  width: "16px",
  height: "16px",
  color: "#000000",
  flexShrink: 0,
};

const tabStyles = {
  Tabs: {
    minHeight: "38px",
    width: "100%",
    "& .MuiTabs-indicator": {
      backgroundColor: "#183243",
      height: "5px",
    },
    "& .MuiTabs-flexContainer": {
      gap: "3.5rem",
      paddingLeft: "0.8rem",
    },
  },
  tab: {
    color: "black",
    padding: "0px 0px",
    textTransform: "none",
    minWidth: "unset",
    minHeight: "2.2rem",
    fontSize: "16px",
    fontWeight: 400,
    "&.Mui-selected": {
      color: "black",
    },
  },
};

const NETWORK_POST_OPTIONS = [
  { image: productLogo, title: "Products", serviceType: serviceTypeName?.Product },
  { image: artWorkLogo, title: "Art", serviceType: serviceTypeName?.Art },
  { image: serviceLogo, title: "Service", serviceType: serviceTypeName?.Service },
];

const networkDrawerStyles = {
  drawerBody: {
    minWidth: "31.25rem",
    maxWidth: "31.25rem",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  header: {
    backgroundColor: "#F9F8F8",
    color: "#000000",
    padding: "7px 8px",
  },
};

const networkTypeCardSx = {
  width: "120px",
  height: "120px",
  border: "1px solid #DEDEDE",
  borderRadius: "24px",
  boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.12)",
  backgroundColor: "#FFFFFF",
  cursor: "pointer",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: 1.25,
  px: 1.5,
  py: 1.5,
  transition: "transform 0.2s ease, box-shadow 0.2s ease",
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: "0px 12px 24px rgba(0, 0, 0, 0.14)",
  },
};

// Maps tab index → API type value (null = all)
const TAB_TYPE_MAP = {
  0: null,
  1: serviceTypeName?.Service,
  2: serviceTypeName?.Product,
  3: serviceTypeName?.Art,
};

const MarketPlaceViewList = ({
  setSellerTabLoading,
  isSellerTabLoading,
  isSideBarOpen,
  setSideBarOpen,
  networkTabValue,
  setNetworkTabValue,
}) => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState("");
  const [isBookMarkedPost, setBookMarkedPost] = useState(false);
  const [isNetworkDrawerOpen, setNetworkDrawerOpen] = useState(false);
  const [isAccessDenied, setAccessDenied] = useState(false);
  const sellerPostList = useSelector(
    (state) => state?.arkchatgroup?.sellerPostList
  );
  const userData = useSelector((state) => state?.profile?.profileData?.data);
  const dispatch = useDispatch();

  useEffect(() => {
    setSellerTabLoading(true);
    dispatch(getSellerTabPost()).then(() => {
      setSellerTabLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTabChange = (_event, newValue) => {
    setNetworkTabValue(newValue);
    setBookMarkedPost(false);
    if (newValue === 4) return;
    setSellerTabLoading(true);
    const type = TAB_TYPE_MAP[newValue];
    dispatch(getSellerTabPost(type ? `type=${type}` : undefined)).then(() => {
      setSellerTabLoading(false);
    });
  };

  const handleLikeClick = (post_id) => {
    dispatch(handleLikePost(post_id)).then(() => {
      const type = TAB_TYPE_MAP[networkTabValue];
      dispatch(getSellerTabPost(type ? `type=${type}` : undefined)).then(() => {
        setSellerTabLoading(false);
      });
    });
  };

  const handleBookmarkClick = (post_id) => {
    dispatch(handleBookmarkPost(post_id)).then(() => {
      const type = TAB_TYPE_MAP[networkTabValue];
      const params = [
        isBookMarkedPost ? "bookmark=true" : null,
        type ? `type=${type}` : null,
      ]
        .filter(Boolean)
        .join("&");
      dispatch(getSellerTabPost(params || undefined)).then(() => {
        setSellerTabLoading(false);
      });
    });
  };

  const handleGetBookMark = () => {
    const nextValue = !isBookMarkedPost;
    setBookMarkedPost(nextValue);
    setSellerTabLoading(true);
    const type = TAB_TYPE_MAP[networkTabValue];
    const params = [
      nextValue ? "bookmark=true" : null,
      type ? `type=${type}` : null,
    ]
      .filter(Boolean)
      .join("&");
    dispatch(getSellerTabPost(params || undefined)).then(() => {
      setSellerTabLoading(false);
    });
  };

  const isOrganisation = userData?.activeSubscriber?.subscriberPriority === accountType?.Organisation;
  const isIndividual = userData?.activeSubscriber?.subscriberPriority === accountType?.Individual;
  const activePermission = userData?.activePermission;

  const handleOpenNetworkDrawer = () => {
    dispatch(getCountryList());
    setNetworkDrawerOpen(true);
  };

  const handleNetworkCardClick = (type) => {
    localStorage.clear();
    dispatch(handleSavePreviewEditPostData({}));
    localStorage.setItem("tabValue", 0);

    if (isOrganisation && activePermission !== AccountLevelArkchatPermission?.USER) {
      dispatch(handleSetserviceTypePost(type));
      setNetworkDrawerOpen(false);
      navigate("/post/post-create", { state: { postCreateSource: "network" } });
      return;
    }

    if (
      isIndividual &&
      activePermission !== AccountLevelArkchatPermission?.USER
    ) {
      dispatch(handleSetserviceTypePost(type));
      setNetworkDrawerOpen(false);
      navigate("/post/post-create", { state: { postCreateSource: "network" } });
      return;
    }

    setAccessDenied(true);
  };

  const handleSidebarToggle = () => {
    setSideBarOpen((prevState) => !prevState);
  };

  const handleEditClick = (data) => {
    dispatch(handleSetserviceTypePost(data?.type));
    dispatch(getServiceCategory(data?.type));
    const createPostData = {
      category: data?.category,
      core_team: {},
      subscriber_id: data?.subscriber_id,
      tags: data?.tags || [],
      topic_id: 0,
      type: data?.type,
      countries: data?.countries || [],
      post_data: data?.postData,
      tagsInput: "",
    };
    const countriesArray = data?.countries?.map((name) => ({ name }));

    const localPreviewData = {
      selectedCategory: data?.category,
      createPostData: createPostData,
      selectedCountries: countriesArray,
      selectedImageList: data?.attachments,
      selectedVideoList: data?.attachments,
      post_id: data?.post_id,
      authorized_seller: data?.authorizedSeller,
      editBrandData: data?.brandInfo,
      editArtistData: data?.artistInfo,
    };
    dispatch(handleSavePreviewEditPostData(localPreviewData));
    localStorage.setItem("post_id", JSON.stringify(data?.id));
    let tabValue;
    if (
      data?.type === serviceTypeName?.Service ||
      data?.type === serviceTypeName?.Art ||
      data?.type === serviceTypeName?.Product
    ) {
      tabValue = 0;
    } else if (data?.type === serviceTypeName?.Photo) {
      tabValue = 1;
    } else if (data?.type === serviceTypeName?.Videos) {
      tabValue = 2;
    }
    localStorage?.setItem("tabValue", tabValue);
    navigate("/post/post-create");
  };

  return (
    <Box sx={{ height: "100%", overflow: "hidden", display: "flex", flexDirection: "column" }}>
      {!userData?.tooltipMarketplaceScreenWeb && (
        <HelperScreen
          title={"How Arkchat Network works"}
          updateKey={"tooltip_marketplace_screen_web"}
          contactSections={[
            { id: "network-discover", content: [appContent?.KEY150] },
            { id: "network-listings", content: [appContent?.KEY151] },
            { id: "network-browse", content: [appContent?.KEY152] },
            { id: "network-group", content: [appContent?.KEY153] },
            { id: "network-contacts", content: [appContent?.KEY389] },
            { id: "network-free", content: [appContent?.KEY390] },
          ]}
        />
      )}

      <StyledSubHeadingBox>
        <Box width={"100%"} display={"flex"} alignItems={"center"}>
          <Tabs
            value={networkTabValue}
            onChange={handleTabChange}
            sx={tabStyles.Tabs}
          >
            <Tab disableRipple sx={tabStyles.tab} label="All" />
            <Tab disableRipple sx={tabStyles.tab} label="Services" />
            <Tab disableRipple sx={tabStyles.tab} label="Products" />
            <Tab disableRipple sx={tabStyles.tab} label="Art" />
            <Tab disableRipple sx={tabStyles.tab} label="My Listings" />
          </Tabs>
        </Box>
      </StyledSubHeadingBox>

      <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", overflow: "hidden" }}>
        {networkTabValue !== 4 && <Stack
          alignItems="center"
          direction="row"
          spacing={1.2}
          paddingX={"1rem"}
          marginTop={"0.8rem"}
        >
          <IconButtonBox
            onClick={handleSidebarToggle}
            size="small"
            variant="text"
          >
            <FilterAltOutlinedIcon sx={actionIconSx} />
          </IconButtonBox>
          <SearchBar>
            <InputBase
              value={searchValue}
              onChange={(event) => setSearchValue(event.target.value)}
              placeholder="Search"
              sx={{
                flex: 1,
                px: 1.5,
                fontSize: "16px",
                color: "#000000",
              }}
            />
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "30px",
                height: "100%",
              }}
            >
              <SearchOutlinedIcon sx={{ color: "#183243", fontSize: 20 }} />
            </Box>
          </SearchBar>
          <IconButtonBox
            onClick={handleGetBookMark}
            size="small"
            variant="text"
          >
            <BookmarkBorderOutlinedIcon sx={actionIconSx} />
          </IconButtonBox>
        </Stack>}

        {networkTabValue === 4 && (
          <Box mt={"1.2rem"} px={"1rem"} sx={{ flex: 1, minHeight: 0, overflow: "auto", "&::-webkit-scrollbar": { width: "0px" } }}>
            <MyFeedPostsTab feed="network" isSideBarOpen={isSideBarOpen} />
          </Box>
        )}

        {networkTabValue !== 4 && isSellerTabLoading && (
          <Box>
            <LoadingSpinner />
          </Box>
        )}
        {networkTabValue !== 4 && !isSellerTabLoading && (
          <Box
            mt={"1.2rem"}
            px={"1rem"}
            sx={{
              flex: 1,
              minHeight: 0,
              overflow: "auto",
              "&::-webkit-scrollbar": {
                width: "0px",
              },
              "&::-webkit-scrollbar-track": {
                background: "#f1f1f1",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "#888",
                borderRadius: "3px",
              },
            }}
          >
            {sellerPostList?.posts?.length > 0 ? (
              <ResponsiveMasonry
                columnsCountBreakPoints={{
                  1194: !isSideBarOpen ? 3 : 2,
                  1195: !isSideBarOpen ? 4 : 3,
                }}
              >
                <Masonry gutter="0.5rem">
                  {sellerPostList?.posts.map((data, i) => (
                    <Box width={"100%"} key={i + "sellerPostdata"}>
                      <PostCard
                        type={serviceTypeValue[data?.type]}
                        postPreviewData={data}
                        showBtn={false}
                        sellerTab={true}
                        handleBookmarkClick={handleBookmarkClick}
                        handleLikeClick={handleLikeClick}
                        handleEditClick={handleEditClick}
                      />
                    </Box>
                  ))}
                </Masonry>
              </ResponsiveMasonry>
            ) : (
              <ExploreView type={TAB_TYPE_MAP[networkTabValue] ?? 0} />
            )}
          </Box>
        )}
      </Box>

      <Box zIndex={1000} position={"fixed"} bottom={"1rem"} right={"2.4rem"}>
        <Fab
          onClick={handleOpenNetworkDrawer}
          sx={{
            bgcolor: "#DB0011",
            "&:hover": { backgroundColor: "#DB0011" },
          }}
          color="primary"
        >
          <AddIcon />
        </Fab>
      </Box>

      <AlertPopUp
        title={"Access Denied."}
        bodyContent={"You don't have permission to create posts."}
        open={isAccessDenied}
        closeModal={setAccessDenied}
      />

      <Drawer sx={{ zIndex: 1202 }} open={isNetworkDrawerOpen} anchor="right">
        <Box sx={networkDrawerStyles.drawerBody}>
          <Stack direction="row" alignItems="center" spacing={2} sx={networkDrawerStyles.header}>
            <Typography onClick={() => setNetworkDrawerOpen(false)} sx={crossIconDiv}>
              <CloseIcon sx={crossIcon} />
            </Typography>
            <Typography>List Globally</Typography>
          </Stack>
          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: 4,
              px: 3,
            }}
          >
            <Box sx={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: 3 }}>
              {NETWORK_POST_OPTIONS.filter((item) => item.serviceType !== serviceTypeName?.Product || isOrganisation).map((item) => (
                <Box key={item.title} sx={networkTypeCardSx} onClick={() => handleNetworkCardClick(item.serviceType)}>
                  <Box
                    component="img"
                    src={item.image}
                    alt={item.title}
                    sx={{ width: "47px", height: "41px", objectFit: "contain" }}
                  />
                  <Typography
                    sx={{
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "16px",
                      fontWeight: 400,
                      color: "#000000",
                      textAlign: "center",
                    }}
                  >
                    {item.title}
                  </Typography>
                </Box>
              ))}
            </Box>
            <Typography
              sx={{
                fontFamily: "Poppins, sans-serif",
                fontSize: "16px",
                fontWeight: 400,
                color: "#000000",
                textAlign: "center",
                lineHeight: 1.6,
              }}
            >
              Get discovered globally. Collaborate instantly and <br /> grow your revenue.
              <br />
              <br />
              Free Listing. No commissions. Ever.
            </Typography>
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
};

export default MarketPlaceViewList;
